export const fifthrows = [
  {
    organisation: "House Guardians",
    role: "House Guardian",
    duration: "Sep 2023 - Apr 2024",
    jobscope: [
      {
        description:
          "Re-appointed as a House Guardian to promote the residential life among 30+ residents on the same level in hostel over a period of 1 year",
      },
    ],
    repeat: 0,
  },
  {
    organisation: "KAIST Silver Lining",
    role: "Volunteer Member",
    duration: "Mar 2023 - Jun 2023",
    jobscope: [
      {
        description:
          "Befriended a group of 8-12 year old students at Yeoldu Gwangjuri Children Care Centre (지역아동센터 열두) through engaging science experiments",
      },
      {
        description:
          "Came up with engaging science experiments that were suitable for the age group of the target audience, such as catapults, trying to make paper float on water, balancing dolls",
      },
      {
        description:
          "Participated in regular weekly meetings, as well as membership training sessions",
      },
    ],
    repeat: 2,
  },
  {
    organisation:
      "10th Student Government (ROOT) and 6th Student Association Council (SAC)",
    role: "Vice-President (Operations)",
    duration: "Feb 2022 - Feb 2023",
    jobscope: [
      {
        description:
          "Facilitated and supported activities of the 10th Student Government (ROOT) and 6th Student Association Council (SAC)",
      },
      {
        description:
          "Formulated events and initiatives to improve SUTD’s mental health and volunteering landscape through collaborations with external organisations such as the Health Promotion Board and Singapore Red Cross",
      },
      {
        description:
          "Designed a Mental Wellness Corner for students to recharge and seek respite after a long day",
      },
      {
        description:
          "Organised a school-wide Blood Donation Drive, Basic Helping Skills workshop, and internal Peer Support Training for ROOT and SAC members",
      },
      {
        description:
          "Coordinated internal ROOT affairs and organising ROOT’s archives and meeting minutes",
      },
      {
        description:
          "Developed and maintained cordial relationships with SUTD’s senior management",
      },
      {
        description:
          'Represented SUTD in the <a href="https://lkyspp.nus.edu.sg/ips/events/details/young-singaporeans-conference-2022-uncharted" target="_blank" rel="noopener noreferrer" class="text-green dark:text-green-dark underline underline-offset-2">Young Singaporeans Conference 2022: Uncharted</a> and the <a href="https://www.pmo.gov.sg/Newsroom/National-Day-Rally-2022-English" target="_blank" rel="noopener noreferrer" class="text-green dark:text-green-dark underline underline-offset-2">National Day Rally 2022</a> by PM Lee Hsien Loong',
      },
      {
        description:
          'Awarded the Student Leader Award and Outstanding Student Organisation Award in the <a href="https://www.sutd.edu.sg/campus-life/student-life/student-awards/student-achievement-awards/2023-winners/#tabs" target="_blank" rel="noopener noreferrer" class="text-green dark:text-green-dark underline underline-offset-2">SUTD Student Achievement Awards 2023</a>',
      },
    ],
    repeat: 0,
  },
  {
    organisation: "Inter-University Network (IUN)",
    role: "Inter-University Network Representative",
    duration: "Feb 2022 - Feb 2023",
    jobscope: [
      {
        description:
          "The IUN represents over 65000 undergraduates across Singapore’s universities/colleges",
      },
      {
        description:
          "Helped with minute taking during regular monthly meetings",
      },
      {
        description:
          'Attended dialogues and events such as the <a href="https://youtube.com/playlist?list=PLbnMTcZEga8S1gAgUsy_UaSgMrbGHfN1E&amp;si=sqaubVXF_Wf6VLJ0" target="_blank" rel="noopener noreferrer" class="text-green dark:text-green-dark underline underline-offset-2">CNA Youth Forum 2022</a> with DPM Lawrence Wong and various ForwardSG dialogues',
      },
    ],
    repeat: 1,
  },
  {
    organisation: "Rotaract Club of SUTD",
    role: "President",
    duration: "Jul 2021 - Aug 2022",
    jobscope: [
      {
        description:
          "Led a team of 10 EXCO members and executed various projects to serve the local and overseas community in Vietnam and Laos despite the COVID-19 pandemic",
      },
      {
        description:
          "Maintained constant contact with our supporting Rotary Club, the Rotary Club of Pandan Valley, and attended their events on a regular basis",
      },
      {
        description: "Increased the club membership by 30 in 6 months",
      },
      {
        description:
          "Coordinated a fundraising and awareness campaign with the National Kidney Foundation and raised $1161 in 1 month",
      },
      {
        description:
          'Awarded the Humanitarian Award (Group) and Outstanding Student Organisation Award in the <a href="https://www.sutd.edu.sg/campus-life/student-life/student-awards/student-achievement-awards/2023-winners/#tabs" target="_blank" rel="noopener noreferrer" class="text-green dark:text-green-dark underline underline-offset-2">SUTD Student Achievement Awards 2023</a>',
      },
    ],
    repeat: 2,
  },
  {
    organisation: "House Guardians",
    role: "Secretary",
    duration: "May 2021 - May 2022",
    jobscope: [
      {
        description:
          "Led the creation of and designing of 4 new e-newsletters, which were emailed to SUTD’s hostel residents",
      },
      {
        description:
          "Coordinated 4 internal workshops for House Guardians, to boost their ability in promoting residential life in SUTD",
      },
      {
        description:
          "Maintained and refactored code of the Telegram Bot used for rental of board games to hostel residents",
      },
      {
        description:
          "Designed infographics for hotlines providing mental health support, as well as anti-abuse or anti-gambling hotlines, which were later put up in all toilet cubicles",
      },
      {
        description:
          "Designed posters to introduce all House Guardians to residents in each block",
      },
      {
        description:
          "Worked with other House Guardian EXCO members to coordinate and publicise the recruitment of new members",
      },
    ],
    repeat: 2,
  },
  {
    organisation: "House Guardians",
    role: "House Guardian",
    duration: "Jan 2021 - Aug 2022",
    jobscope: [
      {
        description:
          "Promoted the residential life among 35 residents on the same level in hostel over a period of 1 year",
      },
      {
        description:
          "Organised more than 5 bonding events to encourage social integration among residents",
      },
      {
        description: "Received at least 4 positive affirmations from residents",
      },
      {
        description:
          "Helped to execute hostel-wide events for all hostel residents",
      },
    ],
    repeat: 1,
  },
  {
    organisation: "5th Student Association Council (SAC)",
    role: "Community Cluster Representative",
    duration: "Nov 2020 - Jan 2022",
    jobscope: [
      {
        description:
          "Represented the interests of 12 clubs in the Community Cluster at SAC meetings",
      },
      {
        description:
          "Liaised with clubs and SUTD’s Office of Student Life to convey concerns that were obtained through regular contact and conducting surveys",
      },
      {
        description:
          "Led a team of 15 volunteers to organise a school-wide fundraising and awareness campaign which raised $2713 in 15 days for SUTD’s janitors, operations department, security guards and gardeners, and interviewed 9 staff over 2 days (Blanja @ SUTD)",
      },
      {
        description:
          "Launched a collaboration with the Ministry of Manpower and Youth Corps Singapore to befriend migrant workers",
      },
      {
        description: `Set up an Instagram page (<a className="text-green dark:text-green-dark underline underline-offset-2" href="https://instagram.com/sutdcommserve" target="_blank" rel="noopener noreferrer">@sutdcommserve</a>) and designed Instagram posts to promote the Community Service clubs in the cluster, gaining 120 followers in 3 months`,
      },
    ],
    repeat: 2,
  },
  {
    organisation: "Students Cohort Class Committee",
    role: "Planning and Coordination for University and Cohort Events Rep",
    duration: "Sep 2020 - May 2021",
    jobscope: [
      {
        description:
          "Organised various bonding events for the class, including a night cycling event, mid-autumn lantern walk, secret santa, valentine's day, and Chinese New Year celebrations",
      },
      {
        description:
          "Packed welfare packs and sent well wishes to the class during the final exams period",
      },
    ],
    repeat: 2,
  },
  {
    organisation: "Rotaract Club of SUTD",
    role: "Community Service Director",
    duration: "Aug 2020 - Jul 2021",
    jobscope: [
      {
        description:
          "Coordinated 15 volunteers to run science experiments for 30 P4-P6 students over 6 months on Zoom and in-person",
      },
      {
        description:
          "Collaborated with HCA Hospice Care to equip members with knowledge and skills to care for the seniors",
      },
      {
        description:
          "Collaborated with Vanguard Healthcare to usher in the new year with 20 elderly beneficiaries and 5 volunteers",
      },
      {
        description:
          'Awarded the Humanitarian Award (Individual) and Humanitarian Award (Group) in the <a href="https://www.sutd.edu.sg/campus-life/student-life/student-awards/student-achievement-awards/2022-winners/#tabs" target="_blank" rel="noopener noreferrer" class="text-green dark:text-green-dark underline underline-offset-2">SUTD Student Achievement Awards 2022</a>',
      },
    ],
    repeat: 1,
  },
  // {
  //   organisation: "FoodAID Club",
  //   role: "Student Advisor",
  //   duration: "Jan 2019 - Jan 2020",
  //   jobscope: [
  //     {
  //       description: "Guided a team of 10 main committee members",
  //     },
  //     {
  //       description:
  //         "Awarded the Outstanding Community Service Award (Team) under NP Student Awards 2020",
  //     },
  //   ],
  //   repeat: 2,
  // },
  // {
  //   organisation: "Engineering Science Academic Club",
  //   role: "President",
  //   duration: "Apr 2018 - May 2019",
  //   jobscope: [
  //     {
  //       description:
  //         "Led the club in organising events for Engineering Science students and events in collaboration with the School of Engineering Society",
  //     },
  //     {
  //       description:
  //         "Created overall direction, mission and vision for the club",
  //     },
  //   ],
  //   repeat: 2,
  // },
  // {
  //   organisation: "FoodAID Club",
  //   role: "Events Coordinator",
  //   duration: "Jan 2018 - Jan 2019",
  //   jobscope: [
  //     {
  //       description:
  //         "Organised the inaugural Food Donation Drive in collaboration with Food from the Heart (FFTH)",
  //     },
  //     {
  //       description:
  //         "Coordinated various community service events such as Y Food of Love, FFTH Packing and Distribution",
  //     },
  //   ],
  //   repeat: 1,
  // },
];
